import { Box, Grid, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useTheme } from '@mui/material/styles';
import { TableHeaderProps } from '../../../types/table';
import { ReactComponent as SentimentsIcon } from '../../../assets/images/icons/sidebar/sentiments.svg';
import { sizeByBreakpoint, textSizeByBreakpoint } from '../../../utils/helper';
import { InfoOutlined } from '@ant-design/icons';

const TableHeader = ({
  title,
  subTitle,
  icon = SentimentsIcon,
  // info,
  headerContent,
  headerSx,
  titleSx,
  children,
  showIcon = true
}: TableHeaderProps) => {
  const theme = useTheme();
  const Icon = icon ? (icon as React.ElementType) : icon;

  return (
    <Grid
      display="flex"
      flexDirection="column"
      gap={sizeByBreakpoint(2, 26)}
      sx={{
        marginBottom: sizeByBreakpoint(2, 26),
        ...headerSx
      }}
    >
      <Grid
        container
        display="flex"
        direction="row"
        flexWrap="wrap"
        alignItems="center"
        justifyContent="space-between"
        gap={sizeByBreakpoint(1, 15)}
      >
        <Grid>
          <Grid display="flex" alignItems="center" gap="5px">
            {showIcon && Icon && (
              <Box
                component={Icon}
                sx={{
                  width: sizeByBreakpoint(1, 24),
                  height: sizeByBreakpoint(1, 24),
                  color: theme.palette.primary.main
                }}
              />
            )}
            <Typography
              variant="subtitle2"
              color="textPrimary"
              lineHeight="100%"
              sx={{
                fontSize: textSizeByBreakpoint(18),
                ...titleSx
              }}
            >
              {title}
            </Typography>
            {subTitle && (
              <Tooltip title={subTitle}>
                <Box
                  sx={{
                    border: `1px solid ${theme.palette.border.main}`,
                    marginLeft: sizeByBreakpoint(0, 5),
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    // cursor: 'pointer'
                    width: sizeByBreakpoint(1, 18),
                    height: sizeByBreakpoint(1, 18)
                  }}
                >
                  <InfoOutlined
                    style={{
                      color: theme.palette.text.primary
                    }}
                  />
                </Box>
              </Tooltip>
            )}
          </Grid>
          {/* {subTitle && (
            <Typography
              variant="body2"
              color="textSecondary"
              lineHeight="100%"
              marginTop="8px"
              sx={{
                fontSize: textSizeByBreakpoint(14)
              }}
            >
              {subTitle}
            </Typography>
          )} */}
        </Grid>
        {headerContent}
      </Grid>
      {children}
    </Grid>
  );
};

export default TableHeader;
